import * as React from "react";

const WIDE_BREAKPOINT_PX = 600;

export function useIsWide(ref: React.RefObject<HTMLElement>): boolean {
  const [isWide, setIsWide] = React.useState(false);

  React.useEffect(() => {
    const element = ref.current;
    if (!element) {
      return undefined;
    }

    const observer = new ResizeObserver((entries) => {
      const width = entries[0]?.contentRect.width ?? 0;
      setIsWide(width >= WIDE_BREAKPOINT_PX);
    });

    observer.observe(element);

    return () => observer.disconnect();
  }, [ref]);

  return isWide;
}
